module.exports = __webpack_public_path__ + "img/coins-timer.46a17366.svg";